import { find, get } from 'lodash';

import { useFormContext } from 'react-hook-form';

type InputErrorReturn = {
    (name: string, component: true): React.JSX.Element | null;
    (name: string, component?: false): { message: string };
};

export const useInputError: InputErrorReturn = (name: any, component: any = false) => {
    const {
        formState: { errors }
    } = useFormContext();
    const errorObj = get(errors, name);
    const error = find(errorObj, 'message') || errorObj;

    if (component) {
        return error ? (
            <b className="tw-m-3 tw-text-[12px] tw-text-error" key={error.path}>
                {error.message}
            </b>
        ) : null;
    }

    return error || {};
};
